import Carousel from "antd/es/carousel";
import "./AutoCarousel.css";
import React from "react";

// let screenWidth;
// useEffect(getWindowDimensions(), []);

// function getWindowDimensions() {
//   const { innerWidth: width } = window;
//   screenWidth = width;
//   console.log(screenWidth);
// }

const h3Style = {
	fontFamily: "Montserrat",
	fontSize: "1.5rem",
	fontWeight: 600,
	textTransform: "uppercase",
	marginTop: "2rem",
};
const pStyle = {
	width: "90%",
	fontFamily: "Montserrat",
	fontSize: "1rem",
	fontWeight: 400,
	marginTop: 0,
};

const AutoCarousel = ({ autoplay = false }) => (
	<Carousel
		pauseOnHover={true}
		autoplay={autoplay}
		autoplaySpeed={1750}
		rootClassName="auto_carousel"
	>
		<div>
			<h3 style={h3Style}>Download the App</h3>
			<p style={pStyle}>
				Head over to your app store and download the ZEVO app. It's free
				and available for both Android and iOS devices.
			</p>
		</div>
		<div>
			<h3 style={h3Style}>Apply for a Driver Position</h3>
			<p style={pStyle}>
				Once you've downloaded the app, create your account and complete
				the driver application. You'll need to provide some basic
				information, upload your Commercial Driver License and other
				required documents, and answer a few questions.
			</p>
		</div>
		<div>
			<h3 style={h3Style}>Start Driving!</h3>
			<p style={pStyle}>
				Once your application is approved, you'll be able to log in to
				the app and start accepting driving jobs. You can manage your
				schedule, track your earnings, and get support from our team all
				within the app.
			</p>
		</div>
	</Carousel>
);
export default AutoCarousel;
